import { USER_STROLLERS_DELETE_CONFIRM } from 'mk/autogenerated/translations/UserStrollersWidget.sagas.7dcfe71b8a67c04a7ba431b2d0139667'
import {
    strollers_api_suggest_strollers2_url,
    strollers_api_v2_user_strollers_add_user_stroller_url,
    strollers_api_v2_user_strollers_remove_user_stroller_url,
} from 'mk/urls/functions';
import {
    userStrollersConnectionCreateActions,
    userStrollersConnectionRemoveActions,
    userStrollersReloadSuggestionsApi,
    UserStrollerConnectionCreateNormalizedResponse,
    UserStrollerConnectionCreateTriggerAction,
    UserStrollerReloadSuggestionsNormalizedResponse,
    UserStrollerReloadSuggestionsTriggerAction,
    USER_STROLLER_CONNECTION_CREATE_TRIGGER,
    USER_STROLLER_CONNECTION_REMOVE_TRIGGER,
    USER_STROLLER_RELOAD_SUGGESTIONS_TRIGGER,
} from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.actions';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRGetError } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { normalize } from 'normalizr';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

const logger = getLogger('UserStrollersWidget.sagas');

export interface ApiResponseToConnectUserStroller {
    body: {
        entities: UserStrollerConnectionCreateNormalizedResponse['entities'],
        result: UserStrollerConnectionCreateNormalizedResponse['result'],
    };
}
function* connectUserStroller({ strollerId, username, xhr }: UserStrollerConnectionCreateTriggerAction & XHRAction) {
    yield put(userStrollersConnectionCreateActions.request(strollerId, username));

    try {
        const response: ApiResponseToConnectUserStroller = yield call(() =>
            xhr.post(strollers_api_v2_user_strollers_add_user_stroller_url(), { strollerId, username }),
        );
        yield put(userStrollersConnectionCreateActions.success(strollerId, username, {
            entities: response.body.entities,
            result: response.body.result,
        }));
    } catch (error) {
        logger.error(error);
        yield put(userStrollersConnectionCreateActions.failure(strollerId, username, normalizeError(error)));
    }
}

function* disconnectUserStroller({ strollerId, username, xhr }: UserStrollerConnectionCreateTriggerAction & XHRAction) {
    if (!window.confirm(USER_STROLLERS_DELETE_CONFIRM)) {
        return;
    }
    yield put(userStrollersConnectionRemoveActions.request(strollerId, username));

    try {
        yield call(() => xhr.post(strollers_api_v2_user_strollers_remove_user_stroller_url(), { strollerId, username }));
        yield put(userStrollersConnectionRemoveActions.success(strollerId, username));
    } catch (error) {
        logger.error(error);
        yield put(userStrollersConnectionRemoveActions.failure(strollerId, username, normalizeError(error)));
    }
}

function* reloadStrollerSuggestions({ searchTerm, xhr }: UserStrollerReloadSuggestionsTriggerAction & XHRAction) {
    yield put(userStrollersReloadSuggestionsApi.request(searchTerm));

    try {
        const response = yield call(() =>
            xhr.get(strollers_api_suggest_strollers2_url(), { searchTerm }),
        );
        const normalizedResponse: UserStrollerReloadSuggestionsNormalizedResponse = normalize(response.body, {});
        yield put(userStrollersReloadSuggestionsApi.success(searchTerm, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(userStrollersReloadSuggestionsApi.failure(searchTerm, normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        takeEvery(USER_STROLLER_CONNECTION_CREATE_TRIGGER, connectUserStroller),
        takeEvery(USER_STROLLER_CONNECTION_REMOVE_TRIGGER, disconnectUserStroller),
        takeLatest(USER_STROLLER_RELOAD_SUGGESTIONS_TRIGGER, reloadStrollerSuggestions),
    ]);
}
